import ErrorSlothSvg from '../svg/ErrorSlothSvg';
import { Container } from './Hero.styles';

const ErrorHero = () => {
  return (
    <Container>
      <ErrorSlothSvg />
    </Container>
  );
};

export default ErrorHero;
